import React from 'react';
import { Assignment } from '../../types';
import { format } from 'date-fns';

interface RecentAssignmentsProps {
  assignments: Assignment[];
}

const getStatusColor = (status: string) => {
  switch (status) {
    case 'ASSIGNED':
      return 'bg-blue-100 text-blue-800';
    case 'IN_PROGRESS':
      return 'bg-orange-100 text-orange-800';
    case 'COMPLETED':
      return 'bg-emerald-100 text-emerald-800';
    default:
      return 'bg-gray-100 text-gray-800';
  }
};

export const RecentAssignments: React.FC<RecentAssignmentsProps> = ({ assignments }) => {
  return (
    <div className="bg-white rounded-lg shadow">
      <div className="px-6 py-4 border-b border-gray-200">
        <h3 className="text-lg font-semibold text-gray-900">Recent Assignments</h3>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead className="bg-gray-50 border-b border-gray-200">
            <tr>
              <th className="px-6 py-3 text-left text-sm font-semibold text-gray-900">
                Journey ID
              </th>
              <th className="px-6 py-3 text-left text-sm font-semibold text-gray-900">Driver</th>
              <th className="px-6 py-3 text-left text-sm font-semibold text-gray-900">Route</th>
              <th className="px-6 py-3 text-left text-sm font-semibold text-gray-900">Date</th>
              <th className="px-6 py-3 text-left text-sm font-semibold text-gray-900">Status</th>
            </tr>
          </thead>
          <tbody>
            {assignments.map((assignment) => (
              <tr key={assignment.assignmentId} className="border-b border-gray-200 hover:bg-gray-50">
                <td className="px-6 py-4 text-sm text-gray-900">{assignment.journeyId}</td>
                <td className="px-6 py-4 text-sm text-gray-600">{assignment.driverId}</td>
                <td className="px-6 py-4 text-sm text-gray-600">{assignment.routeName}</td>
                <td className="px-6 py-4 text-sm text-gray-600">
                  {format(new Date(assignment.date), 'MMM dd, yyyy')}
                </td>
                <td className="px-6 py-4 text-sm">
                  <span className={`px-3 py-1 rounded-full text-xs font-medium ${getStatusColor(assignment.status)}`}>
                    {assignment.status}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
